import { format } from "date-fns";
import { NUMERIC_DATE_TIME_FORMAT } from "./constants";

export const formatUnixTimestamp = (
  ts,
  intendedFormat = NUMERIC_DATE_TIME_FORMAT
) => {
  const date = new Date(ts);
  return format(date, intendedFormat);
};
